import React, { useState } from 'react';
import DemoTracePanel from './DemoTracePanel';

const LiveChatMessage = ({ message }) => {
  const [showMetadata, setShowMetadata] = useState(false);

  const getMessageClass = () => {
    switch (message.type) {
      case 'user':
        return 'live-chat-message-user';
      case 'cerebral':
        return 'live-chat-message-cerebral';
      case 'error':
        return 'live-chat-message-error';
      case 'system':
        return 'live-chat-message-system';
      default:
        return '';
    }
  };

  const getSpeakerLabel = () => {
    switch (message.type) {
      case 'user':
        return 'You';
      case 'cerebral':
        return 'Cerebral';
      case 'error':
        return 'Error';
      case 'system':
        return 'System';
      default:
        return '';
    }
  };

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className={`live-chat-message ${getMessageClass()}`}>
      {/* Header */}
      <div className="live-chat-message-header">
        <span className="live-chat-message-speaker">{getSpeakerLabel()}</span>
        <span className="live-chat-message-time">{formatTimestamp(message.timestamp)}</span>
      </div>

      {/* Content */}
      <div className="live-chat-message-content">
        {message.content}
      </div>

      {/* Execution Trace */}
      {message.type === 'cerebral' && message.execution_trace && (
        <div style={{ marginTop: '8px' }}>
          <DemoTracePanel executionTrace={message.execution_trace} />
        </div>
      )}

      {/* Metadata (expandable) */}
      {message.metadata && Object.keys(message.metadata).length > 0 && (
        <div className="live-chat-message-metadata">
          <details open={showMetadata} onToggle={(e) => setShowMetadata(e.target.open)}>
            <summary>View Details</summary>
            <pre>{JSON.stringify(message.metadata, null, 2)}</pre>
          </details>

          {/* Quick info for scores */}
          {message.metadata.score !== undefined && (
            <div style={{ marginTop: '6px' }}>
              <strong>Score:</strong> {message.metadata.score?.toFixed(4) || 'N/A'}
            </div>
          )}

          {/* Top outcome nodes */}
          {message.metadata.top_outcome_nodes && message.metadata.top_outcome_nodes.length > 0 && (
            <div style={{ marginTop: '6px' }}>
              <strong>Top Outcome Nodes:</strong>
              <ul style={{ margin: '4px 0', paddingLeft: '20px', fontSize: '11px' }}>
                {message.metadata.top_outcome_nodes.slice(0, 5).map((node, idx) => (
                  <li key={idx}>{node}</li>
                ))}
                {message.metadata.top_outcome_nodes.length > 5 && (
                  <li>... and {message.metadata.top_outcome_nodes.length - 5} more</li>
                )}
              </ul>
            </div>
          )}

          {/* Process execution status */}
          {message.metadata.status && (
            <div 
              className={`process-execution-status ${message.metadata.status}`}
              style={{ marginTop: '8px' }}
            >
              <strong>Process Status:</strong> {message.metadata.status}
              {message.metadata.progress !== undefined && (
                <span> ({Math.round(message.metadata.progress * 100)}% complete)</span>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LiveChatMessage;
